import { Controller } from "@hotwired/stimulus"

// Segmented-pill toggle for a boolean profile field.
// data-values: url, field ('user[display_as_username]')
export default class extends Controller {
  static values = { url: String, field: String }

  async select(event) {
    const button = event.currentTarget
    const value = button.dataset.value

    this.element.querySelectorAll("button").forEach((b) => {
      const selected = b === button
      b.classList.toggle("bg-warm-600", selected)
      b.classList.toggle("text-white", selected)
      b.classList.toggle("shadow-sm", selected)
      b.classList.toggle("text-gray-500", !selected)
      b.classList.toggle("hover:bg-warm-50", !selected)
    })

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    const body = new URLSearchParams()
    body.set(this.fieldValue, value)
    try {
      await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "X-CSRF-Token": token,
          "Content-Type": "application/x-www-form-urlencoded",
          "Accept": "application/json"
        },
        credentials: "same-origin",
        body: body.toString()
      })
    } catch {
      /* soft-fail */
    }
  }
}
